import { Article, Category } from '../services/help-center-query.service'

export const getSameSectionArticles = (
  categories: Category[] | [],
  targetSlug: string,
): Article[] | [] => {
  return categories.flatMap(category =>
    category.articles.find(article => article.slug === targetSlug)
      ? category.articles.filter(article => article.slug !== targetSlug)
      : [],
  )
}
